import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Main from './Components/Home/Main'
import Login from './Components/Account/Login'
import Signup from './Components/Account/Signup'
import Contact from './Components/Pages/Contact'
import Propitorship from './Components/Pages/NewBussiness/Propitorship'
import ScrollToTopButton from './Components/Pages/ScrollToTop'
import Review from './Components/Pages/Review'
import PartnerShip from './Components/Pages/NewBussiness/PartnerShip'
import Rewards from './Components/Pages/Rewards'


function App() {
  return (
    <>
     
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/login" element={<Login/>}/>
          <Route path="/Signup" element={<Signup/>}/>
          <Route path="/contact" element={<Contact/>}/>
          <Route path="/Propitorship" element={<Propitorship/>}/>
          <Route path="/partnership" element={<PartnerShip/>}/>
          <Route path="/review" element={<Review/>}/>
          <Route path="/reward" element={<Rewards/>}/>
        </Routes>
        <ScrollToTopButton/>
    
      
    </>
  )
}

export default App